import { useQueryClient } from 'react-query';

import { queryKey } from '../../justifications.query-keys';

export const useInvalidateAllJustifications = () => {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries(queryKey.justifications());
    };
};
